import { useState } from "react";
import TextInput from "../../../../components/auth/TextInput";
import SelectInput from "../../../../components/auth/SelectInput";
import Button from "../../../../components/auth/Button";
import { completeProfile } from "../../../../api/restaurantAuth";
import iranProvinces from "../../../../data/iranLocations.json";

const ACTIVITY_TYPES = [
  { value: "restaurant", label: "رستوران" },
  { value: "cafe", label: "کافه" },
  { value: "fastfood", label: "فست‌فود" },
  { value: "bakery", label: "قنادی" },
];

export default function ProfileStep({ registrationToken, rememberMe, onCompleted, onExpired }) {
  const [form, setForm] = useState({ name: "", province: "", activityType: "", email: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (key) => (e) => setForm((prev) => ({ ...prev, [key]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.name || !form.province || !form.activityType) {
      setError("لطفاً نام مجموعه، استان و نوع مجموعه را تکمیل کنید.");
      return;
    }

    try {
      setLoading(true);
      setError("");
      const data = await completeProfile(registrationToken, { ...form, email: form.email.trim() }, rememberMe);
      onCompleted(data);
    } catch (err) {
      const code = err.response?.data?.error?.code;
      if (code === "INVALID_REGISTRATION_TOKEN" || code === "REGISTRATION_TOKEN_REQUIRED") {
        onExpired();
        return;
      }
      setError(err.response?.data?.error?.message || "تکمیل ثبت‌نام با خطا مواجه شد.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <p className="text-sm text-gray-500 text-center -mt-1">
        شماره شما تایید شد. برای تکمیل ثبت‌نام، اطلاعات مجموعه‌تان را وارد کنید.
      </p>

      <TextInput
        label="نام مجموعه"
        value={form.name}
        onChange={handleChange("name")}
        placeholder="مثلاً رستوران بامیزبان"
        required
      />

      <SelectInput
        label="استان"
        value={form.province}
        onChange={handleChange("province")}
        options={Object.keys(iranProvinces).map((item) => ({ value: item, label: item }))}
        required
      />

      <SelectInput
        label="نوع مجموعه"
        value={form.activityType}
        onChange={handleChange("activityType")}
        options={ACTIVITY_TYPES}
        required
      />

      <TextInput
        label="ایمیل (اختیاری)"
        type="email"
        value={form.email}
        onChange={handleChange("email")}
        placeholder="example@gmail.com"
      />

      {error && <p className="text-center text-red-500 text-xs">{error}</p>}

      <Button type="submit" loading={loading}>
        تکمیل ثبت‌نام
      </Button>
    </form>
  );
}
